import ApiService from "@/services/api.service";

let route = "uploads";

const uploads = {
  get(_id) {
    return new Promise((resolve, reject) => {
      ApiService.get(route, _id).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  add(_module) {
    return new Promise((resolve, reject) => {
      ApiService.post(route, _module).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  edit(_id, _module) {
    return new Promise((resolve, reject) => {
      ApiService.patch(route, _id, _module).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  rem(_id) {
    return new Promise((resolve, reject) => {
      ApiService.delete(route, _id).then(
        ({ data }) => {
          resolve(data);
        },
        error => {
          reject(error);
        }
      );
    });
  }
};

export default uploads;
